export default __webpack_public_path__ + "static/media/background.8e682306.png";